import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ExcelReportsJson } from "../../DynamicFormsJson/MastersJSON/excelReports";
import { getStakeHolderNameByStakeholderTypeAndAreaPostNew } from "../../Slice/StackHolder.slice";
import {
	getAreaByTalukaPostBodyUpdated,
	getAreaByUserType,
} from "../../Slice/area.slice";
import { getBeatsByAreasPostUpdated } from "../../Slice/beat.slice";
import {
	getCategory,
	getCategoryByAssinedBrand,
} from "../../Slice/category.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getAllProductByCategories } from "../../Slice/product.slice";
import { getRegionNew } from "../../Slice/region.slice";
import {
	getSalesExecutiveByUserType,
	getSalesPersonByAreaPost,
} from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import {
	getStockStakeHolderBySelfAndBelowOrder,
	getStockStakeHolderType,
} from "../../Slice/stockStakeHolderType.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { getOtherTask } from "../../Slice/otherTask.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicReportGenerate";
import config from "../../config/config";
import endpoint from "../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";

class ExcelReports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dynamicMasterData: {
				regionDetail: this.props.regionList?.region,
				stateDetail: this.props.stateList?.stateByRegion,
				zoneDetail: this.props.zoneList?.zoneByState,
				districtDetail: this.props.districtList?.districtByZone,
				talukaDetail: this.props.talukaList?.talukaByDistrict,
				areaDetail: this.props.areaList?.areaByTaluka,
				areaDetailForDealer: this.props.areaList?.area,
				beatDetail: this.props.beatList.beat,
				categoryDetail: this.props.categoryList.category,
				productDetail: this.props.productList.productByCategory,
				stockStakeHolderTypeDetail:
					this.props.stockStakeHolderType?.stockStakeHolderType,
				salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
			},
			adminFlag: false,
			areaIds: "",
			reportIndexList: [],
			listForReports: [],
		};
	}

	async componentDidMount() {
		const {
			getRegionNew,
			getAreaByUserType,
			getStockStakeHolderBySelfAndBelowOrder,
			getCategory,
			getCategoryByAssinedBrand,
			getOtherTask,
			getSalesExecutiveByUserType,
			showLoador,
			showNotification,
			getStockStakeHolderType,
		} = this.props;
		if (navigator.onLine) {
			const userTypeId = localStorage.getItem("userTypeId");

			const reportIndexList =
				localStorage.getItem("showExcelReportsBySettingValues") &&
				localStorage.getItem("showExcelReportsBySettingValues").split(",");

			this.setState({ reportIndexList: reportIndexList });

			if (userTypeId == 1 || userTypeId == 6) {
				this.setState({
					adminFlag: true,
				});
				showLoador({ loador: true });
				await getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
					({ success, response }) => {
						console.log(response);
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}

			const showCompanyFlag = localStorage.getItem("showCompanyFlag");

			this.rowDataGklAdm(reportIndexList);

			showLoador({ loador: true });
			await getRegionNew().then(({ success }) => {
				showLoador({ loador: false });
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});

			showLoador({ loador: true });
			await getAreaByUserType().then(({ success }) => {
				showLoador({ loador: false });
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});

			if (userTypeId == 2) {
				showLoador({ loador: true });
				await getCategoryByAssinedBrand().then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			} else {
				showLoador({ loador: true });
				await getCategory().then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (userTypeId == 1 || userTypeId == 6) {
				showLoador({ loador: true });
				await getStockStakeHolderType({
					userTypeIds:
						showCompanyFlag == 2 && userTypeId == 2
							? "2"
							: showCompanyFlag == 2
								? "3,4"
								: " 2 ",
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			} else {
				showLoador({ loador: true });
				await getStockStakeHolderBySelfAndBelowOrder().then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			showLoador({ loador: true });
			await getOtherTask().then(({ success }) => {
				showLoador({ loador: false });
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});
		} else {
			showNotification({ msg: noInternetMsg, severity: "error" });
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.regionList !== nextProps.regionList) {
			if (this.props.regionList?.region !== nextProps.regionList?.region) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						regionDetail: nextProps.regionList?.region,
					},
				});
			}
		}

		if (this.props.salesPersonList !== nextProps.salesPersonList) {
			if (
				this.props.salesPersonList?.salesPersonByArea !==
				nextProps.salesPersonList?.salesPersonByArea
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
					},
				});
			}
		}

		if (this.props.stateList !== nextProps.stateList) {
			if (
				this.props.stateList?.stateByRegion !==
				nextProps.stateList?.stateByRegion
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stateDetail: nextProps.stateList?.stateByRegion,
					},
				});
			}
		}
		if (this.props.zoneList !== nextProps.zoneList) {
			if (
				this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						zoneDetail: nextProps.zoneList?.zoneByState,
					},
				});
			}
		}
		if (this.props.districtList !== nextProps.districtList) {
			if (
				this.props.districtList?.districtByZone !==
				nextProps.districtList?.districtByZone
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						districtDetail: nextProps.districtList?.districtByZone,
					},
				});
			}
		}
		if (this.props.talukaList !== nextProps.talukaList) {
			if (
				this.props.talukaList?.talukaByDistrict !==
				nextProps.talukaList?.talukaByDistrict
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						talukaDetail: nextProps.talukaList?.talukaByDistrict,
					},
				});
			}
		}
		if (this.props.areaList !== nextProps.areaList) {
			if (
				this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						areaDetail: nextProps.areaList?.areaByTaluka,
					},
				});
			}
		}
		if (this.props.areaList !== nextProps.areaList) {
			if (this.props.areaList?.area !== nextProps.areaList?.area) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						areaDetailForDealer: nextProps.areaList?.area,
					},
				});
			}
		}

		if (this.props.beatList !== nextProps.beatList) {
			if (this.props.beatList?.beat !== nextProps.beatList?.beat) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						beatDetail: nextProps.beatList?.beat,
					},
				});
			}
		}
		if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
			if (
				this.props.stockStakeHolderType?.stockStakeHolderType !==
				nextProps.stockStakeHolderType?.stockStakeHolderType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stockStakeHolderTypeDetail:
							nextProps.stockStakeHolderType?.stockStakeHolderType,
					},
				});
			}
		}
		if (this.props.stakeholderList !== nextProps.stakeholderList) {
			if (
				this.props.stakeholderList?.stackholderNameFromType !==
				nextProps.stakeholderList?.stackholderNameFromType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stakeHolderName: nextProps.stakeholderList?.stackholderNameFromType,
					},
				});
			}
		}
		if (this.props.categoryList !== nextProps.categoryList) {
			if (
				this.props.categoryList?.category !== nextProps.categoryList?.category
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						categoryDetail: nextProps.categoryList?.category,
					},
				});
			}
		}

		if (this.props.productList !== nextProps.productList) {
			if (
				this.props.productList?.productByCategory !==
				nextProps.productList?.productByCategory
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						productDetail: nextProps.productList?.productByCategory,
					},
				});
			}
		}

		if (this.props.otherTaskList !== nextProps.otherTaskList) {
			if (
				this.props.otherTaskList?.otherTask !==
				nextProps.otherTaskList?.otherTask
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						otherTaskDetail: nextProps.otherTaskList?.otherTask,
					},
				});
			}
		}
	}

	getListById = async (data) => {
		const {
			getStateByRegion,
			getZoneByState,
			getDistrictByZone,
			getTalukaByDistrict,
			getAreaByTalukaPostBodyUpdated,
			getAllProductByCategories,
			getBeatsByAreasPostUpdated,
			getSalesPersonByAreaPost,
			showLoador,
			getStakeHolderNameByStakeholderTypeAndAreaPostNew,
			getSalesExecutiveByUserType,
			showNotification,
		} = this.props;
		const { areaIds, adminFlag } = this.state;
		if (navigator.onLine) {
			console.log(data);

			this.setState({
				fromDate: dayjs(data.fromDate).format("DD-MM-YYYY"),
				toDate: dayjs(data.toDate).format("DD-MM-YYYY"),
			});

			if (data.area) {
				this.setState({
					areaIds: data.area,
				});
			}

			if (data.region && data.region != "") {
				showLoador({ loador: true });
				await getStateByRegion({ regionIds: data.region }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}
			if (data.state && data.state != "") {
				showLoador({ loador: true });
				await getZoneByState({ stateIds: data.state }).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}
			if (data.zone && data.zone != "") {
				showLoador({ loador: true });
				await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}
			if (data.district && data.district != "") {
				showLoador({ loador: true });
				await getTalukaByDistrict({ districtIds: data.district }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}
			if (data.taluka && data.taluka != "") {
				let talukaJson = {
					talukaIds: data.taluka,
				};
				showLoador({ loador: true });
				await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaJson }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}
			if (data.area && data.area != "") {
				let beatJson = {
					areaIds: data.area,
				};
				showLoador({ loador: true });
				await getBeatsByAreasPostUpdated({ beatDataForPost: beatJson }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}

			if (!adminFlag) {
				if (data.area && data.area != "") {
					let areaIdsJson = {
						areaIds: data.area,
					};
					showLoador({ loador: true });
					await getSalesPersonByAreaPost({ areaIdsJson: areaIdsJson }).then(
						({ success }) => {
							showLoador({ loador: false });
							if (!success) {
								showNotification({ msg: serverMsg, severity: "error" });
							}
						},
					);
				}
			}

			if (data.category && data.category != "") {
				showLoador({ loador: true });
				await getAllProductByCategories({
					categoryIds: data.category,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (data.stockStakeHolderTypeId && data.stockStakeHolderTypeId != "") {
				let jsonData = {
					stockStakeHolderTypeIds: data.stockStakeHolderTypeId.split(","),
					areaIds: areaIds,
				};
				showLoador({ loador: true });
				await getStakeHolderNameByStakeholderTypeAndAreaPostNew({
					jsonData: jsonData,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	};

	getExcelByReport = (row, rowData) => {
		const { showLoador, showNotification } = this.props;

		if (navigator.onLine) {
			if (rowData.uniqueIndexValue == 10) {
				const dataToSave = {
					fromDate: row.fromDate,
					toDate: row.toDate,
					areaIds: row.area,
					stockStakeHolderTypeId: row.stockStakeHolderTypeId,
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.salesExecutive + "/with-check-in-out-report-excel",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 11) {
				const dataToSave = {
					month: dayjs(row.month, "DD-MM-YYYY").format("MM-YYYY"),
					zoneIds: row.zone,
					otherTaskIds: row.otherTaskIds,
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReports +
						"/sales-team-monthly-activity-report-excel",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 8) {
				let dataJson = {
					month: dayjs(row.month, "DD-MM-YYYY").format("MM-YYYY"),
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/get-all-sales-team-attendence-detailed-report-excel",
					postBody: dataJson,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 9) {
				let dataJson = {
					month: dayjs(row.month, "DD-MM-YYYY").format("MM-YYYY"),
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReports +
						"/get-all-sales-team-attendence-summary-report-excel",
					postBody: dataJson,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 12) {
				let dataJson = {
					fromDate: row.fromDate,
					toDate: row.toDate,
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReports +
						"/sales-team-wise-category-report-excel",
					postBody: dataJson,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 13) {
				let dataJson = {
					fromDate: row.fromDate,
					toDate: row.toDate,
				};
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReports +
						"/sales-team-wise-sub-category-report-excel-new-format",
					postBody: dataJson,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 14) {
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.reportForExcelReports + "/master-data-report-excel",
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (
				rowData.uniqueIndexValue == 1 ||
				rowData.uniqueIndexValue == 27
			) {
				const dataToSave = {
					fromDate: row.fromDate,
					toDate: row.toDate,
					categoryIds: row.category,
					productIds: row.product,
					stockStakeHolderId: row.stockStakeHolder,
					beatIds: row.beat,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.monthlySalesAnalysisLatest + "/new",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 3) {
				/*Changes By Tejas - 
        Added validation to call the SQL dump API 
      when the below condition is met, after March 31, 2025.*/

				const isToDateAfterDate = dayjs(row.toDate, "DD-MM-YYYY").isAfter(
					dayjs("31-03-2025", "DD-MM-YYYY"),
				)
					? true
					: false;

				if (isToDateAfterDate) {
					showLoador({ loador: true });
					downloadF({
						isGet: true,
						url:
							endpoint.dumpNew +
							"/exportexcel?fromDate2=" +
							row.fromDate +
							"&toDate2=" +
							row.toDate,
						ext: "xls",
						openNewTab: false,
					}).then((response) => {
						if (!response) {
							showNotification({
								msg: serverMsg,
								severity: "error",
							});
						}
						showLoador({ loador: false });
					});
				} else {
					showLoador({ loador: true });
					downloadF({
						isGet: false,
						url:
							endpoint.reportForExcelReportsLatest +
							"/product-sale-register?fromDate=" +
							row.fromDate +
							"&toDate=" +
							row.toDate,
						ext: "xls",
						openNewTab: false,
					}).then((response) => {
						if (!response) {
							showNotification({
								msg: serverMsg,
								severity: "error",
							});
						}
						showLoador({ loador: false });
					});
				}
			} else if (rowData.uniqueIndexValue == 5) {
				const dataToSave = {
					stateIds: row.state,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.stackholderLatest + "/distributor-assign-excel-by-date",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 6) {
				const dataToSave = {
					stockStakeHolderIds: row.stockStakeHolder,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/product-sale-register-by-date-and-distributors-from-dump",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 29) {
				/*Changes By Tejas - 
       Added validation to call the Product Wise sales register API 
     when the below condition is met, after March 31, 2025.*/

				const isToDateAfterDate = dayjs(row.toDate, "DD-MM-YYYY").isAfter(
					dayjs("31-03-2025", "DD-MM-YYYY"),
				)
					? true
					: false;

				if (isToDateAfterDate) {
					const dataToSave = {
						fromDate: row.fromDate,
						toDate: row.toDate,
						salesTeamIds: row.salesPerson,
						beatIds: row.beat,
						categoryIds: row.category,
						stockStakeHolderIds: row.stockStakeHolder,
					};

					showLoador({ loador: true });
					downloadF({
						isGet: false,
						url:
							endpoint.exportDataNew +
							"/product-wise-sale-register-for-stock-stake-holder-from-dump",
						postBody: dataToSave,
						ext: "xls",
						openNewTab: false,
					}).then((response) => {
						if (!response) {
							showNotification({
								msg: serverMsg,
								severity: "error",
							});
						}
						showLoador({ loador: false });
					});
				} else {
					const dataToSave = {
						fromDate: row.fromDate,
						toDate: row.toDate,
						salesTeamIds: row.salesPerson,
						beatIds: row.beat,
						categoryIds: row.category,
						stockStakeHolderIds: row.stockStakeHolder,
					};

					showLoador({ loador: true });
					downloadF({
						isGet: false,
						url:
							endpoint.exportDataNew +
							"/product-wise-sale-register-for-stock-stake-holder",
						postBody: dataToSave,
						ext: "xls",
						openNewTab: false,
					}).then((response) => {
						if (!response) {
							showNotification({
								msg: serverMsg,
								severity: "error",
							});
						}
						showLoador({ loador: false });
					});
				}
			} else if (rowData.uniqueIndexValue == 30) {
				const dataToSave = {
					fromDate: row.fromDate,
					toDate: row.toDate,
					stockStakeHolderIds: row.stockStakeHolder,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.stackholderLatest + "/bill-excel",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 32) {
				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/product-crn-register?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 33) {
				const dataToSave = {
					stockStakeHolderIds: row.stockStakeHolder,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/product-crn-register-by-date-and-distributors",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} 
		} else {
			showNotification({ msg: noInternetMsg, severity: "error" });
		}
	};

	rowDataGklAdm = (reportIndexList) => {
		let adminFlagForReports = false;

		if (
			localStorage.getItem("userTypeId") &&
			(localStorage.getItem("userTypeId") == 1 ||
				localStorage.getItem("userTypeId") == 6)
		) {
			adminFlagForReports = true;
		}

		let listForReports = [];

		if (adminFlagForReports && reportIndexList.includes("1")) {
			listForReports.push({
				isStatic: true,
				index: 1,
				uniqueIndexValue: 1,
				reportName: "Monthly Sales Analysis Report (Admin - D0 to D12)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,beat,category,product,stockStakeHolderTypeId,stockStakeHolder",
				url: "/api/distributionreport/v1/monthly-sales-analysis?fromDate={fromDate}&toDate={toDate}&categoryIds={category}&productIds={product}&salesTeamId={stockStakeHolder}&beatIds={beat}&flag=0",
				days: 124,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("2")) {
			listForReports.push({
				index: 2,
				uniqueIndexValue: 2,
				reportName: "Distributor Report (Admin - D0 to D7, D11, D12)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,stockStakeHolderTypeId,stockStakeHolder,",
				url: "/api/distributionreport/v1/monthly-sale-bill-analysis/new?fromDate={fromDate}&toDate={toDate}&distributorId={stockStakeHolder}",
				days: 124,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("3")) {
			listForReports.push({
				isStatic: true,
				index: 3,
				uniqueIndexValue: 3,
				reportName: "SQL Dump (Admin - D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/api/distribution/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
				days: 7,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("4")) {
			listForReports.push({
				index: 4,
				uniqueIndexValue: 4,
				reportName: "Purchase Bill (Admin - D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/stock-stake-holder-bill-header/generated-bills-excel-by-date?fromDate={fromDate}&toDate={toDate}",
				days: 124,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("5")) {
			listForReports.push({
				isStatic: true,
				index: 5,
				uniqueIndexValue: 5,
				reportName: "Distributor Assign Report (Admin - D0 to D3)",
				filter: "fromDate,toDate,region,state",
				url: "/api/distributionreport/v1/stock-stake-holder/distributor-assign-excel",
				days: 124,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("6")) {
			listForReports.push({
				isStatic: true,
				index: 6,
				uniqueIndexValue: 6,
				reportName: "SQL Dump Stakeholder wise(Admin - D0 to D7, D11, D12)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,stockStakeHolderTypeId,stockStakeHolder",
				url: "/api/distributionreport/v1/stock-stake-holder/product-sale-register",
				days: 31,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("7")) {
			listForReports.push({
				index: 7,
				uniqueIndexValue: 7,
				reportName: "Distributor Assign Report For All (Admin - D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/stock-stake-holder/distributor-assign-report-excel-by-date?fromDate={fromDate}&toDate={toDate}",
				days: 124,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("8")) {
			listForReports.push({
				isStatic: true,
				index: 8,
				uniqueIndexValue: 8,
				reportName: "Sales Team Attendance Detailed Report ( Admin - D14)",
				filter: "month",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("9")) {
			listForReports.push({
				isStatic: true,
				index: 9,
				uniqueIndexValue: 9,
				reportName: "Sales Team Attendance Summary Report ( Admin - D14)",
				filter: "month",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("10")) {
			listForReports.push({
				isStatic: true,
				index: 10,
				uniqueIndexValue: 10,
				reportName:
					"Sales Team Report With Check In-Out Status Excel ( Admin - D0, D1, D3 to D8, D13)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,stockStakeHolderTypeId",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("11")) {
			listForReports.push({
				isStatic: true,
				index: 11,
				uniqueIndexValue: 11,
				reportName: "Manager Activity Report ( Admin - D2 to D5, D12)",
				filter: "month,region,state,zone,otherTaskIds",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("12")) {
			listForReports.push({
				isStatic: true,
				index: 12,
				uniqueIndexValue: 12,
				reportName: "Sales Team Category Wise Report ( Admin - D0 & D1)",
				filter: "fromDate,toDate",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("13")) {
			listForReports.push({
				isStatic: true,
				index: 13,
				uniqueIndexValue: 13,
				reportName: "Sales Team Sub-Category Wise Report ( Admin - D0 & D1)",
				filter: "fromDate,toDate",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("14")) {
			listForReports.push({
				isStatic: true,
				index: 14,
				uniqueIndexValue: 14,
				reportName: "Master Data Report",
				filter: "",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("15")) {
			listForReports.push({
				index: 15,
				uniqueIndexValue: 15,
				reportName: "Daily Stock Report (D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/stock-consumption-header/get-daily-stock-excel-by-date?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("16")) {
			listForReports.push({
				index: 16,
				uniqueIndexValue: 16,
				reportName: "Material Inward Report (D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/material-inward?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("17")) {
			listForReports.push({
				index: 17,
				uniqueIndexValue: 17,
				reportName: "Party Wise Sale (D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/party-wise-sales?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("18")) {
			listForReports.push({
				index: 18,
				uniqueIndexValue: 18,
				reportName: "Product Wise sale (D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/product-wise-sales?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("19")) {
			listForReports.push({
				index: 19,
				uniqueIndexValue: 19,
				reportName: "Invoice Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/invoice?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("20")) {
			listForReports.push({
				index: 20,
				uniqueIndexValue: 20,
				reportName: "Credit Note Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/crn?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("21")) {
			listForReports.push({
				index: 21,
				uniqueIndexValue: 21,
				reportName: "Pending Orders Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/product-wise-stock-holder-order?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("22")) {
			listForReports.push({
				index: 22,
				uniqueIndexValue: 22,
				reportName: "Pending Orders Product Wise(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/order?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("23")) {
			listForReports.push({
				index: 23,
				uniqueIndexValue: 23,
				reportName: "FG Production Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/fg-production?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("24")) {
			listForReports.push({
				index: 24,
				uniqueIndexValue: 24,
				reportName: "Purchase Return Quantity Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/grn?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("25")) {
			listForReports.push({
				index: 25,
				uniqueIndexValue: 25,
				reportName: "Invoice Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/invoice?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("26")) {
			listForReports.push({
				index: 26,
				uniqueIndexValue: 26,
				reportName: "Date Wise In-Stock Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/month-wise-and-date-wise-stock-report?fromDate={fromDate}&toDate={toDate}&status=1",
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("27")) {
			listForReports.push({
				isStatic: true,
				index: 27,
				uniqueIndexValue: 27,
				reportName: "Monthly Sales Analysis Report ( Distributor - D0 to D7)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,beat,category,product,stockStakeHolderTypeId,stockStakeHolder",
				url: "/api/distributionreport/v1/monthly-sales-analysis?fromDate={fromDate}&toDate={toDate}&categoryIds={category}&productIds={product}&salesTeamId={stockStakeHolder}&beatIds={beat}&flag=0",
				days: 124,
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("28")) {
			listForReports.push({
				index: 28,
				uniqueIndexValue: 28,
				reportName: "Distributor Report ( Distributor - D0 To D2, D6, D7)",
				filter: "fromDate,toDate,area,stockStakeHolderTypeId,stockStakeHolder,",
				url: "/api/distributionreport/v1/monthly-sale-bill-analysis/new?fromDate={fromDate}&toDate={toDate}&distributorId={stockStakeHolder}",
				days: 124,
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("29")) {
			listForReports.push({
				isStatic: true,
				index: 29,
				uniqueIndexValue: 29,
				reportName:
					"Product Wise Sale Register (Distributor - D0 to D4, D6, D7, D8)",
				filter:
					"fromDate,toDate,area,beat,category,stockStakeHolderTypeId,salesPerson,stockStakeHolder",
				url: "/api/distributionreport/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
				days: 31,
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("30")) {
			listForReports.push({
				isStatic: true,
				index: 30,
				uniqueIndexValue: 30,
				reportName: "Stakeholder Bill (Distributor - D0 To D2, D6, D7)",
				filter: "fromDate,toDate,area,stockStakeHolderTypeId,stockStakeHolder",
				url: "/api/distributionreport/v1/stock-stake-holder/bill-excel",
				days: 124,
			});
		}

		if (!adminFlagForReports && reportIndexList.includes("31")) {
			listForReports.push({
				index: 31,
				uniqueIndexValue: 31,
				reportName: "Outlet Wise Bill Report ( Distributor - D0 to D2, D6, D7)",
				filter: "fromDate,toDate,area,stockStakeHolderTypeId,stockStakeHolder,",
				url: "/api/distributionreport/v1/outlet-bill-header/get-outlet-wise-bill-excel?fromDate={fromDate}&toDate={toDate}&stockStakeHolderId={stockStakeHolder}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("32")) {
			listForReports.push({
				isStatic: true,
				index: 32,
				uniqueIndexValue: 32,
				reportName: "Credit Note Dump (Admin - D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distribution/v1/report/product-crn-register?fromDate={fromDate}&toDate={toDate}",
				days: 7,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("33")) {
			listForReports.push({
				isStatic: true,
				index: 33,
				uniqueIndexValue: 33,
				reportName:
					"Credit Note Dump Stakeholder Wise (Admin - D0 to D7, D11, D12)",
				filter:
					"fromDate,toDate,region,state,zone,district,taluka,area,stockStakeHolderTypeId,stockStakeHolder",
				url: "/api/distribution/v1/report/product-crn-register-by-date-and-distributors",
				days: 31,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("34")) {
			listForReports.push({
				index: 34,
				uniqueIndexValue: 34,
				reportName: "Order Sales Person Wise Report (Admin - D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/export/sales-teams-by-order-and-zero-order-list-excel?fromDate={fromDate}&toDate={toDate}",
			});
		}

		if (adminFlagForReports && reportIndexList.includes("37")) {
			listForReports.push({
				index: 37,
				uniqueIndexValue: 37,
				reportName: "Attendence Summary Report Excel (Admin - D0 to D1, D15)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/report/attendence-summary-report-excel?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
			});
		}

		const finalReportList = listForReports.map((dataObj, index) => {
			return {
				...dataObj,
				index: index + 1,
			};
		});

		this.setState({ listForReports: finalReportList });
	};

	render() {
		const { dynamicMasterData, adminFlag, listForReports } = this.state;
		return (
			<>
				<DynamicMainScreen
					maxDateValid={true}
					getExcel={this.getExcelByReport}
					screenTitle={ExcelReportsJson.screenTitle}
					fieldMeta={
						adminFlag
							? ExcelReportsJson.fieldMetaForAdmin
							: ExcelReportsJson.fieldMetaForDistributor
					}
					buttonCenter={ExcelReportsJson.buttonCenter}
					dynamicMasterData={dynamicMasterData}
					getListById={this.getListById}
					searchButton={ExcelReportsJson.searchButton}
					PDFButton={ExcelReportsJson.PDFButton}
					EXCELButton={ExcelReportsJson.EXCELButton}
					baseIdColumn={ExcelReportsJson.baseIdColumn}
					apiBaseURL={ExcelReportsJson.apiBaseURL}
					marginTop={ExcelReportsJson.marginTop}
					openNewTab={true}
					rowData={listForReports}
				/>
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	beatList: state.beat,
	areaList: state.area,
	regionList: state.region,
	stateList: state.states,
	zoneList: state.zone,
	districtList: state.district,
	talukaList: state.taluka,
	stockStakeHolderType: state.stockStakeHolderType,
	categoryList: state.category,
	stakeholderList: state.stockholder,
	productList: state.product,
	salesPersonList: state.salesExecutive,
	otherTaskList: state.otherTask,
});
const mapDispatchToProps = {
	showNotification,
	showLoador,
	getRegionNew,
	getZoneByState,
	getOtherTask,
	getDistrictByZone,
	getTalukaByDistrict,
	getAreaByTalukaPostBodyUpdated,
	getAreaByUserType,
	getStockStakeHolderType,
	getStateByRegion,
	getBeatsByAreasPostUpdated,
	getStockStakeHolderBySelfAndBelowOrder,
	getCategory,
	getCategoryByAssinedBrand,
	getStakeHolderNameByStakeholderTypeAndAreaPostNew,
	getSalesPersonByAreaPost,
	getAllProductByCategories,
	getSalesExecutiveByUserType,
};
export default connect(mapStateToProps, mapDispatchToProps)(ExcelReports);
